import { Link } from 'react-router-dom'
import type { CustomerWidgetProps } from '@ztechapps/webui.contract'
import { UserWidget } from '@ztechapps/webui.input'
import { routesDef } from '../../config/routes'

// The conversation rail's requester block, bound to `WebuiIocKey.customer.customerWidget`: a
// QuickScore requester is always a teacher, so the shared block links to the teacher's detail page
// instead of a customer or company contact.
export const TeacherWidget = ({ profile, status, phone, contactId }: CustomerWidgetProps) => {
  const widget = <UserWidget status={status} profile={profile} phone={phone} />

  return contactId ? <Link to={routesDef.TeacherDetailPage.altPath({ _id: contactId })}>{widget}</Link> : widget
}
